/**
 * @stable
 */
export interface Link {
    url?: string;
    target?: 'self' | 'top' | 'parent' | null;
    attributes?: { [attr: string]: string };
}

export class AuthDetails {
    authCode: string = '';
    authFlag: boolean = false;
    cashierType: CashierType | undefined;
}

export enum CashierType {
    MainCashier = 'MainCashier',
    BetSlipQd = 'BetSlipQd',
    QdOverlay = 'QdOverlay',
}

export interface SessionInfo {
    [x: string]: string | number | undefined | null;
    brandId: string;
    channelId: string;
    productId: string;
    LANG_ID: string;
    sessionKey: string;
    userId: string;
    stake: string;
    walletBucketType: string;
    version: string;
    estimatedReturn: string;
    frontend: string;
    hideChat: string;
    bonusCodeForPrefill: string;
}

export interface ChatRequest {
    isCashier?: boolean;
    isPageLoad?: boolean;
    websiteUrl?: string;
    ipAddress?: string;
    pageUrl?: string;
    action?: string;
    isFromQD?: boolean;
}
